module.exports = __webpack_public_path__ + "media/images/ohap_gradebook_correct-5a2b28be2a392aac204e81ee9f5773c8.png";